const sidewallColors = new Map();

class KmSidewallColor extends HTMLElement {
  connectedCallback() {
    this.control = this.querySelector('select');
    this.scope = this.closest('dialog, .shopify-section, product-card') || this.parentElement;
    this.key = `${this.scope.id}:${this.dataset.productId}`;
    this.control.value = sidewallColors.get(this.key) || 'Hvit';
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.control.addEventListener('change', () => {
      sidewallColors.set(this.key, this.control.value);
    }, { signal });
    this.scope.addEventListener('change', (event) => {
      if (event.target === this.control) return;
      this.sync();
    }, { capture: true, signal });
    this.closest('form')?.addEventListener('formdata', (event) => {
      this.sync();
      if (this.hidden) event.formData.delete(this.control.name);
      else event.formData.set(this.control.name, this.control.value);
    }, { signal });
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.scope, { childList: true, subtree: true });
    this.sync();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }

  sync() {
    const picker = Array.from(this.scope.querySelectorAll('variant-picker'))
      .find((element) => element.dataset.productId === this.dataset.productId);
    let value;
    if (picker) {
      const radio = Array.from(picker.querySelectorAll('input[type="radio"]:checked'))
        .find((input) => /sidevegg/i.test(input.dataset.optionName || input.name));
      const dropdown = Array.from(picker.querySelectorAll('select'))
        .find((select) => /sidevegg/i.test(select.name));
      value = radio?.value ?? dropdown?.value;
      if (value === undefined) {
        const single = Array.from(picker.querySelectorAll('[data-testid="variant-option-single"]'))
          .find((element) => /sidevegg/i.test(element.textContent));
        value = single?.querySelector('[data-testid="variant-option-single-value"]')?.textContent;
      }
    }
    const active = value === undefined ? this.dataset.active === 'true' : /^\s*[12]\s+sidevegg/i.test(value);
    this.hidden = !active;
    this.control.disabled = !active;
  }
}

if (!customElements.get('km-sidewall-color')) {
  customElements.define('km-sidewall-color', KmSidewallColor);
}
